<button mat-icon-button aria-label="Excel Export" type="button" class="export-button" (click)="downloadReport()">
  <i class="fas fa-file-download"></i>
</button>
<app-termresult *ngFor="let elem of data" [data]="elem"></app-termresult>
